import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import Box from '@material-ui/core/Box';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper } from '@material-ui/core';
import {
    Authentication as AUTHENTICATION
} from 'Components/Api/EzyPayAEPSAPI';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    AEPS_OPERATOR_ID,
    AADHARPAY_OPERATOR_ID
} from 'Components/Helper/Messages';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import HOCLoader from 'Components/Loader/HOCLoader';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import usePosition from 'Components/Posistion';
const CustomContainer = HOCLoader(Container);
export const EzyPayAEPSAuthentication = () => {
    const history = useHistory();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }

    const formRef = useRef();
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [Message, setMessage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const Mobile = localStorage.getItem('MobileNumber');
    const aadharNumber = localStorage.getItem('AadharNo');
    const { latitude, longitude, error } = usePosition();

    const [formObj, setFormObj] = useState({
        adhaarnumber: aadharNumber,
        MobileNumber: Mobile,
        FingerPrint: '',
        Latitude: latitude,
        Longitude: longitude
    });
    const reset = () => {
        setFormObj({
            adhaarnumber: '',
            MobileNumber: '',
            FingerPrint: ''
        });
    };

    const validationSchema = Yup.object({
        adhaarnumber: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + 'aadhaar number'),

        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number')
    });
    const SubmitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setResponseMessage('');
        setLoadingOpen(true);

        const { status, xmldata } = await GetFingerPrint('');

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;
        let SelectedOperatorID = 0;
        if (values.IsAEPS) {
            SelectedOperatorID = AEPS_OPERATOR_ID;
        } else if (values.IsAadharPay) {
            SelectedOperatorID = AADHARPAY_OPERATOR_ID;
        }
        var request = {
            FingerPrint: fingerPrintXML,
            AadharNo: values.AadharNo,
            MobileNumber: values.MobileNumber,
            OperatorID: SelectedOperatorID,
            Latitude: latitude,
            Longitude: longitude,
        };
        var requestObj = JSON.stringify(request);
        var response = await AUTHENTICATION(requestObj);

        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
            return;
        }
        setSeverity('success');

        if (!response.status) {

            var data = JSON.parse(response.data); 
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data); 
            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true); 
            if ((data.toLowerCase() === "User Already Authenticated")) {
                history.push('/EPayAEPS');
            }
            return;
        }
        history.push('/EPayAEPS');
    };
    useEffect(() => {
        fetchConsumerNumberFontSize();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={SubmitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Aadhar No"
                                                        name="adhaarnumber"
                                                        placeholder="Aadhar No"
                                                        title="Aadhar No"
                                                        length="12"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Mobile Number"
                                                        name="MobileNumber"
                                                        icon="mobile"
                                                        placeholder="Mobile Number"
                                                        title="Mobile Number"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        <Grid className={classes.footerGrid}>
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <SecondaryButton
                                                                    disabled={
                                                                        loadingOpen
                                                                    }
                                                                    endIcon={
                                                                        <ResetIcon />
                                                                    }
                                                                    title="Reset"
                                                                    onClick={() => {
                                                                        reset();
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-7">
                                                                <PrimaryButton
                                                                    title="Proceed"
                                                                    disabled={
                                                                        loadingOpen
                                                                    }
                                                                    endIcon={
                                                                        <RechargeIcon />
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
